import { MFA_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { IconProps, Icons } from '@silverfort/sf-components';
import { UserStatus } from './types/userStatus';
import { DeviceTokenType } from './types/User';

type IconsType = typeof Icons;
type IconType = IconsType[keyof IconsType];

interface TokenTypeDetails {
    label: string;
    icon: IconType;
    iconClassName?: IconProps['className'];
}

export const SILVERFORT_TOKEN_LIST = {
    [MFA_TYPES.DESKTOP_APP.ID]: { title: MFA_TYPES.DESKTOP_APP.DISPLAY_NAME, value: MFA_TYPES.DESKTOP_APP.ID },
    [MFA_TYPES.MOBILE.ID]: { title: MFA_TYPES.MOBILE.DISPLAY_NAME, value: MFA_TYPES.MOBILE.ID },
    [MFA_TYPES.CHROME.ID]: { title: MFA_TYPES.CHROME.DISPLAY_NAME, value: MFA_TYPES.CHROME.ID }
};

export const THIRD_PARTY_TOKEN_LIST = {
    [MFA_TYPES.HARDWARE.ID]: { title: MFA_TYPES.HARDWARE.DISPLAY_NAME, value: MFA_TYPES.HARDWARE.ID },
    [MFA_TYPES.MICROSOFT.ID]: { title: MFA_TYPES.MICROSOFT.DISPLAY_NAME, value: MFA_TYPES.MICROSOFT.ID },
    [MFA_TYPES.OKTA.ID]: { title: MFA_TYPES.OKTA.DISPLAY_NAME, value: MFA_TYPES.OKTA.ID },
    [MFA_TYPES.DUO.ID]: { title: MFA_TYPES.DUO.DISPLAY_NAME, value: MFA_TYPES.DUO.ID },
    [MFA_TYPES.RSA.ID]: { title: MFA_TYPES.RSA.DISPLAY_NAME, value: MFA_TYPES.RSA.ID },
    [MFA_TYPES.PING.ID]: { title: MFA_TYPES.PING.DISPLAY_NAME, value: MFA_TYPES.PING.ID },
    [MFA_TYPES.HYPR.ID]: { title: MFA_TYPES.HYPR.DISPLAY_NAME, value: MFA_TYPES.HYPR.ID },
    [MFA_TYPES.OTP.ID]: { title: MFA_TYPES.OTP.DISPLAY_NAME, value: MFA_TYPES.OTP.ID }
};

export const TOKEN_TYPE_TO_DETAILS: Record<DeviceTokenType, TokenTypeDetails> = {
    [DeviceTokenType.DESKTOP_APP]: {
        label: MFA_TYPES.DESKTOP_APP.DISPLAY_NAME,
        icon: Icons.SilverfortIcon,
        iconClassName: '[&&]:text-[#231F20]'
    },
    [DeviceTokenType.MS_TEAMS]: {
        label: MFA_TYPES.MS_TEAMS.DISPLAY_NAME,
        icon: Icons.SilverfortIcon,
        iconClassName: '[&&]:text-[#231F20]'
    },
    [DeviceTokenType.MOBILE]: {
        label: MFA_TYPES.MOBILE.DISPLAY_NAME,
        icon: Icons.SilverfortIcon,
        iconClassName: '[&&]:text-[#231F20]'
    },
    [DeviceTokenType.CHROME]: {
        label: MFA_TYPES.CHROME.DISPLAY_NAME,
        icon: Icons.SilverfortIcon,
        iconClassName: '[&&]:text-[#231F20]'
    },
    [DeviceTokenType.HARDWARE]: {
        label: MFA_TYPES.HARDWARE.DISPLAY_NAME,
        icon: Icons.Fido2
    },

    [MFA_TYPES.OTP.ID]: {
        label: MFA_TYPES.OTP.DISPLAY_NAME,
        icon: Icons.OTP
    }
};

export const USER_STATUS_TO_LABEL: Record<UserStatus, string> = {
    [UserStatus.Excluded]: 'Excluded',
    [UserStatus.Paired]: 'Paired',
    [UserStatus.Pending]: 'Pair-Pending',
    [UserStatus.Unpaired]: 'Unpaired',
    [UserStatus.Disabled]: 'Disabled',
    [UserStatus.Unprotected]: 'Unprotected'
};

export const TOKEN_ID_TO_DISPLAY_NAME = Object.values(MFA_TYPES).reduce((acc, { ID, DISPLAY_NAME }) => {
    acc[ID] = DISPLAY_NAME;
    return acc;
}, {});
